import { useEffect, useState } from 'react';

export const useDocumentVisibility = () => {
  const [isDocumentHidden, setIsDocumentHidden] = useState(false);

  useEffect(() => {
    const handleVisibilityChange = () => {
      if (document.hidden) {
        setIsDocumentHidden(true);
      } else {
        setIsDocumentHidden(false);
      }
    };

    document.addEventListener('visibilitychange', handleVisibilityChange);

    return () => {
      document.removeEventListener('visibilitychange', handleVisibilityChange);
    };
  }, []);

  return { isDocumentHidden };
};
